import { Suspense } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { ReactComponent as ReactIconChangeSchedule } from "../../../assets/images/change-schedule.svg";
import { Button } from "../../Buttons";
import stylesModule from "./ModalChangeSchedule.module.sass";
import { useDispatch } from "react-redux";
import {
  clearDataWorkstation,
  stopWorkingWorkstation
} from "../../../redux/dashboard/dashboardSlice";
import { logout } from "../../../redux/session/sessionSlice";

const ModalChangeSchedule = props => {
  const { unmount } = props;

  const dispatch = useDispatch();
  const { t } = useTranslation("general");
  const { t: shiftEnded } = useTranslation("shiftEnded");

  const handleFinishShift = async logoutStatus => {
    await dispatch(stopWorkingWorkstation());
    await dispatch(clearDataWorkstation());
    if (!!logoutStatus) {
      await dispatch(logout());
    }
    unmount();
  };

  return (
    <div className={stylesModule.background}>
      <div className={stylesModule.modal}>
        <div className={stylesModule.content}>
          <h3 className={stylesModule.title}>
            <Suspense fallback={"Cargando..."}>
              {shiftEnded("shiftEnded")}
            </Suspense>
          </h3>
          <ReactIconChangeSchedule />
          <p className={stylesModule.message}>
            <Suspense fallback={"Cargando..."}>
              {shiftEnded("theShiftHasEnded")}
            </Suspense>
          </p>
          <div className={stylesModule.containerBtns}>
            <Button
              onClick={() => handleFinishShift(true)}
              type="primary-invert"
            >
              <Suspense fallback={"Cargando..."}>{t("exitSystem")}</Suspense>
            </Button>
            <Button onClick={() => handleFinishShift(false)} type="primary">
              <Suspense fallback={"Cargando..."}>
                {shiftEnded("nextShift")}
              </Suspense>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

ModalChangeSchedule.propTypes = { unmount: PropTypes.func };

export default ModalChangeSchedule;
